import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import commonFr from './locales/fr/common.json';
import commonEn from './locales/en/common.json';
import landingFr from './locales/fr/landing.json';
import landingEn from './locales/en/landing.json';
import authFr from './locales/fr/auth.json';
import authEn from './locales/en/auth.json';
import notfoundFr from './locales/fr/notfound.json';
import notfoundEn from './locales/en/notfound.json';
import legalFr from './locales/fr/legal.json';
import legalEn from './locales/en/legal.json';
import dashboardFr from './locales/fr/dashboard.json';
import dashboardEn from './locales/en/dashboard.json';
import adminFr from './locales/fr/admin.json';
import adminEn from './locales/en/admin.json';
import pricingFr from './locales/fr/pricing.json';
import pricingEn from './locales/en/pricing.json';

const saved =
  typeof window !== 'undefined'
    ? (() => {
        try {
          return window.localStorage.getItem('i18nextLng');
        } catch {
          return null;
        }
      })()
    : null;

i18n.use(initReactI18next).init({
  resources: {
    fr: {
      common: commonFr,
      landing: landingFr,
      auth: authFr,
      notfound: notfoundFr,
      legal: legalFr,
      dashboard: dashboardFr,
      admin: adminFr,
      pricing: pricingFr,
    },
    en: {
      common: commonEn,
      landing: landingEn,
      auth: authEn,
      notfound: notfoundEn,
      legal: legalEn,
      dashboard: dashboardEn,
      admin: adminEn,
      pricing: pricingEn,
    },
  },
  lng: saved === 'en' || saved === 'fr' ? saved : 'fr',
  fallbackLng: 'fr',
  defaultNS: 'common',
  ns: ['common', 'landing', 'auth', 'notfound', 'legal', 'dashboard', 'admin', 'pricing'],
  interpolation: { escapeValue: false },
});

export default i18n;
